import useTrackPageView from './useTrackPageView';
const TrackPageView = (props) => {
    useTrackPageView(props.enabled);
    return null;
};
export default TrackPageView;
